import { Folder } from '@/api/generatedApi';
import { Box, styled, SxProps, Theme } from '@mui/material';
import { DeleteFolderButton } from './DeleteFolderButton';
import { DownloadFolderButton } from './DownloadFolderButton';
import { MoveFolderButton } from './MoveFolderButton';

const StyledFolderActionRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '2px',
  width: '100%',
  gap: theme.spacing(0.5),
}));

export const FolderActionRow = ({
  folder,
  onDelete,
  sx,
}: {
  folder: Folder;
  onDelete?: () => void;
  sx?: SxProps<Theme>;
}) => (
  <StyledFolderActionRow sx={sx}>
    <DownloadFolderButton folder={folder} />
    <MoveFolderButton folder={folder} />
    <DeleteFolderButton folder={folder} onDelete={onDelete} />
  </StyledFolderActionRow>
);
